import {
  deleteFilterChipHandler,
  getGraphFiltersKey,
} from '../services/common/ChartUtils';
import { setLocalStorageObj } from '../services/common/Utils';

const Reducer = (state, action) => {
  let newGraphFilters;
  let selectedGraphFilter;
  let graphFiltersKey;
  switch (action.type) {
    case 'TOGGLE_DRAWER':
      return {
        ...state,
        toggleDrawer: action.toggleDrawer,
      };
    case 'TOGGLE_MENU_HIGHTLIGHT':
      return {
        ...state,
        isMenuHighlighted: action.isMenuHighlighted,
      };
    case 'OPENED_DRAWER':
      return {
        ...state,
        drawerIsOpened: action.drawerIsOpened,
      };
    case 'PAGINATION':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.pagination,
        },
      };
    case 'CONTEXT_PAGINATION':
      return {
        ...state,
        context_pagination: {
          ...state.context_pagination,
          ...action.context_pagination,
        },
      };
    case 'ALERT':
      return {
        ...state,
        alert: action.alert,
      };
    case 'ACCOUNTS':
      return {
        ...state,
        accounts: action.accounts,
      };
    case 'SELECTED_ACCOUNT':
      return {
        ...state,
        account: action.account,
      };
    case 'ACCOUNT_SUBSCRIPTIONS_DETAILS':
      return {
        ...state,
        subscriptions: action.subscriptions,
      };
    case "SELECTED_THIRDPARTY":
      return {
        ...state,
        thirdparty: action.thirdparty,
      };
    case "SELECTED_THIRDPARTY_CONTACTS":
      return {
        ...state,
        thirdpartyContacts: action.thirdpartyContacts,
      };
    case "USER_ROLES":
      return {
        ...state,
        roles: action.roles,
      };
    case 'USER_INFOS':
      return {
        ...state,
        user: action.user,
      };
    // case "UPDATE_USER_INFOS":
    //   return {
    //     ...state,
    //     user: {
    //       ...state.user,
    //       ...action.user,
    //     },
    //   };
    case 'LANG':
      return {
        ...state,
        lang: action.lang,
      };
    // case "TOKEN":
    //   return {
    //     ...state,
    //     token: action.token,
    //   };
    // case "KEYCLOAK":
    //   return {
    //     ...state,
    //     keycloak: action.keycloak,
    //   };
    case "CONNECT_AS_ROLES":
      return {
        ...state,
        roles: action.roles,
        superAdminConnectedAsRoles: action.superAdminConnectedAsRoles
      };
    case "SUPER_ADMIN_USER":
      return {
        ...state,
        isSuperAdminUser: action.isSuperAdminUser,
      };


    case 'ACTIVITIES_COUNT':
      return {
        ...state,
        activitiesCount: action.activitiesCount,
      };

    case 'DOSSIER_TYPES':
      return {
        ...state,
        dossierTypes: action.dossierTypes,
      };

    case 'INACTIVE_DOSSIER_TYPES':
      return {
        ...state,
        inactiveDossierTypes: action.dossierTypes,
      };

    case 'DOSSIER':
      return {
        ...state,
        dossier: action.dossier,
      };

    case 'CRUMBS':
      return {
        ...state,
        crumbsData: action.crumbsData,
      };

    case 'ADD_GRAPH_FILTER':
      selectedGraphFilter = state.graphFilters[action.filter.type] || [];
      newGraphFilters = {
        ...state.graphFilters,
        [action.filter.type]: [...selectedGraphFilter, action.filter.data],
      };
      graphFiltersKey = getGraphFiltersKey(
        action.filter.accountId,
        action.filter.tab,
        action.filter.subTab
      );
      setLocalStorageObj(graphFiltersKey, newGraphFilters);
      return {
        ...state,
        graphFilters: newGraphFilters,
      };

    case 'REMOVE_GRAPH_FILTER':
      newGraphFilters = deleteFilterChipHandler(
        state.graphFilters,
        action.filter.type,
        action.filter.data
      );
      graphFiltersKey = getGraphFiltersKey(
        action.filter.accountId,
        action.filter.tab,
        action.filter.subTab
      );
      setLocalStorageObj(graphFiltersKey, newGraphFilters);
      return {
        ...state,
        graphFilters: newGraphFilters,
      };

    case 'INIT_GRAPH_FILTER':
      return {
        ...state,
        graphFilters: action.filters,
      };

    // case "AUTH_DONE":
    //   return {
    //     ...state,
    //     isAuthDone: action.isAuthDone,
    //   };
    // case "PROVISIONING_ACCOUNT":
    //   return {
    //     ...state,
    //     provisioning: action.provisioning,
    //   };

    case 'CLEAR_GRAPH_FILTER_BY_ID':
      selectedGraphFilter = state.graphFilters[action.filter.type] || [];
      newGraphFilters = {
        ...state.graphFilters,
        [action.filter.type]: selectedGraphFilter.filter(
          (x) => !x.id.endsWith(action.filter.idEndsWith)
        ),
      };
      graphFiltersKey = getGraphFiltersKey(
        action.filter.accountId,
        action.filter.tab,
        action.filter.subTab
      );
      setLocalStorageObj(graphFiltersKey, newGraphFilters);
      return {
        ...state,
        graphFilters: newGraphFilters,
      };

    case 'CLEAR_GRAPH_FILTERS':
      graphFiltersKey = getGraphFiltersKey(
        action.filter.accountId,
        action.filter.tab,
        action.filter.subTab
      );
      setLocalStorageObj(graphFiltersKey, {});
      return {
        ...state,
        graphFilters: {},
      };

    case 'REFERENCE_DATA':
      return {
        ...state,
        referenceData: action.data,
      };

    case 'SELECTED_CONTEXT_INSTANCE':
      return {
        ...state,
        contextInstance: action.contextInstance,
      };
    case 'SELECTED_CONTEXT_THIRDPARTY':
      return {
        ...state,
        contextThirdParty: action.contextThirdParty,
      };
    case 'IS_CREATING_CONTEXT_INSTANCE':
      return {
        ...state,
        isCreatingContextInstance: action.isCreatingContextInstance,
      };
    case 'IS_ASSOCIATING_CONTEXT_THIRDPARTY':
      return {
        ...state,
        isAssociatingContextThirdParty: action.isAssociatingContextThirdParty,
      };

    case "SET_CONTEXT_MODELS":
      return {
        ...state,
        contextModels: action.payload,
      };

    case "SET_CONTEXT_INSTANCES":
      return {
        ...state,
        contextInstances: action.payload,
      };

    case "SET_CONTEXT_THIRDPARTIES":
      return {
        ...state,
        contextThirdParties: action.payload,
      };
    case "LEGAL_CATEGORY_TRADUCTIONS":
      return {
        ...state,
        legalActivityTraductions: action.data,
      };

    case "PERSONALIZATION":
      return {
        ...state,
        personalization: action.data,
      };

    case "DOCTYPE_TRADUCTIONS":
      return {
        ...state,
        doctypeTraductions: action.data,
      };

    case "ACTIVITY_TRADUCTIONS":
      const activityMapByOrigin = new Map()
      action.data.forEach(activity => {
        const { origine, code } = activity
        let activityMapByCode = activityMapByOrigin.get(origine)
        if (!activityMapByCode) {
          activityMapByCode = new Map()
          activityMapByOrigin.set(origine, activityMapByCode)
        }
        activityMapByCode.set(code, activity)
      })

      return {
        ...state,
        activityTraductions: action.data,
        activityMapByOrigin: activityMapByOrigin,
      };

    case "SET_AVAILABLE_REPORTS":
      return {
        ...state,
        availableReports: action.payload,
      };

    default:
      return state;
  }
};

export default Reducer;
